import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { trackWhatsAppClick } from "@/lib/conversionAnalytics";
import { useMetaPixel } from "@/hooks/useMetaPixel";
import { trackWhatsAppServerSide } from "@/lib/serverTracking";
import { useTrafficSource } from "@/hooks/useTrafficSource";
import { useGoogleAnalytics } from "@/hooks/useGoogleAnalytics";

const WhatsAppButton = () => {
  const { i18n } = useTranslation();
  const { trackWhatsAppClick: trackMetaWhatsApp } = useMetaPixel();
  const trafficSource = useTrafficSource();
  const { trackWhatsAppClick: trackGA4WhatsApp } = useGoogleAnalytics();
  
  const whatsappNumber = i18n.language === 'tr' ? "905491491928" : "905552337895";
  
  const message = i18n.language === 'tr' 
    ? "Merhaba! SULE CLINIC hakkında bilgi almak istiyorum."
    : "Hi! I'd like to learn more about dental treatments at SULE CLINIC.";
  
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  const handleClick = () => {
    console.log('[WhatsApp Floating] Click detected, tracking...');
    console.log('[WhatsApp Floating] GA4 tracking function available:', typeof trackGA4WhatsApp);
    
    // Track in our analytics database
    trackWhatsAppClick('floating', i18n.language, {
      phoneNumber: whatsappNumber,
    });
    
    // Track in Meta Pixel browser-side (compliant - generic content only)
    trackMetaWhatsApp(undefined, i18n.language);
    
    // Track in Google Analytics 4
    trackGA4WhatsApp('floating', i18n.language);
    
    // Track server-side via Meta Conversions API (for users who block pixels)
    trackWhatsAppServerSide({
      source: 'floating',
      language: i18n.language,
      trafficSource: trafficSource.traffic_source,
      trafficMedium: trafficSource.traffic_medium,
      trafficCampaign: trafficSource.traffic_campaign,
    });
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white p-4 md:p-5 rounded-full shadow-xl transition-all duration-300 hover:scale-110"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 md:w-8 md:h-8" />
    </a>
  );
};

export default WhatsAppButton;
